/* eslint no-shadow: ["error", { "allow": ["state"] }] */

import ActivitiesService from '../../services/ActivitiesService';
import ErrorHandlerHelpers from '../../mixins/ErrorHandlerHelpers';

const SET_ACTIVITIES = 'SET_ACTIVITIES';
const CLEAR_ACTIVITIES = 'CLEAR_ACTIVITIES';

const state = {
  activities: null,
  dischargeActivityCodes: ['DIP', 'DIPD'],
};

const getters = {
  getActivityById: (state) => (id) => state.activities.find((x) => x.id === id),
  getDischargeActivityCodes: (state) => state.dischargeActivityCodes,
};

const mutations = {
  [SET_ACTIVITIES](state, activities) {
    state.activities = activities;
  },
  [CLEAR_ACTIVITIES](state) {
    state.activities = null;
  },
};

const actions = ({
  loadAvailableActivities({ commit }, activeSiteId) {
    ActivitiesService.getAvailableActivities(activeSiteId)
      .then((x) => x.data)
      .then((activities) => commit(SET_ACTIVITIES, activities.activities))
      .catch((err) => console.error(err));
  },
  createActivity({ dispatch }, activity) {
    return ActivitiesService.createActivity(activity)
      .then((x) => x.data)
      .then((activityData) => {
        dispatch('loadAvailableActivities', activityData.activity.siteId);
      }).catch(ErrorHandlerHelpers.handleServiceError);
  },
  updateActivity({ dispatch }, activityUpdate) {
    return ActivitiesService.updateActivity(activityUpdate)
      .then((x) => x.data)
      .then((activityData) => {
        dispatch('loadAvailableActivities', activityData.siteId);
      }).catch((err) => {
        ErrorHandlerHelpers.handleServiceError(err);
        return err;
      });
  },
  deleteActivity({ dispatch, rootState }, id) {
    const activeSiteId = rootState.userStore.activeSite
      ? rootState.userStore.activeSite.id
      : rootState.userStore.user.activeSite.id;

    return ActivitiesService.deleteActivity(id)
      .then((x) => dispatch('loadAvailableActivities', activeSiteId))
      .catch((err) => ErrorHandlerHelpers.handleServiceError(err));
  },
});

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
